import"@sitecore/byoc";var r;(function(i){i.Preview="preview",i.Edit="edit",i.Normal="normal"})(r||(r={}));
//# sourceMappingURL=augmentation.js.map
